//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const bitgotx = require('bitgo-utxo-lib');
const axios = require('axios');

export default {
  name: 'App',
  data() {
    return {
      keypair: {
        publickey: '',
        privatekey: '',
      },
      multisig: {
        address: '',
        redeemScript: '',
      },
      publickeys: [],
      inputs: 1,
      reqsig: 1,
      unsignedTx: {
        myAddress: '',
        receiver: '',
        amount: 0,
        message: '',
        hex: '',
      },
      signedTx: {
        rawtx: '',
        privatekey: '',
        redeemScript: '',
        hex: '',
      },
      finalisedTx: {
        rawtx: '',
        hex: '',
      },
      isTestnet: false,
      mainnetExplorer: 'https://explorer.runonflux.io',
      testnetExplorer: 'https://testnet.runonflux.io',
    }
  },
  methods: {
    generateKeypair() {
      const network = this.isTestnet ? bitgotx.networks.fluxtestnet : bitgotx.networks.zelcash
      const keyPair = bitgotx.ECPair.makeRandom({ network });
      // console.log(keyPair);
      const pubKey = keyPair.getPublicKeyBuffer().toString('hex');
      // const address = keyPair.getAddress();
      // console.log(address);

      this.keypair.publickey = pubKey;
      this.keypair.privatekey = keyPair.toWIF();
    },
    generateMultisig() {
      try {
        const filteredPK = this.publickeys.filter(function (el) {
          return el != null && el != "";
        });

        const pubKeysBuffer = filteredPK.map(function (hex) { return Buffer.from(hex, 'hex') })

        const redeemScript = bitgotx.script.multisig.output.encode(Number(this.reqsig), pubKeysBuffer);
        const redeemScriptHex = redeemScript.toString('hex');
        const scriptPubKey = bitgotx.script.scriptHash.output.encode(bitgotx.crypto.hash160(redeemScript));

        const network = this.isTestnet ? bitgotx.networks.fluxtestnet : bitgotx.networks.zelcash
        const address = bitgotx.address.fromOutputScript(scriptPubKey, network);
        this.multisig.address = address;
        this.multisig.redeemScript = redeemScriptHex;
      } catch (e) {
        console.log(e)
        this.multisig.address = e.message;
        this.multisig.redeemScript = e.message;
      }
    },
    addPubKey() {
      this.inputs += 1;
    },
    async buildUnsignedRawTx() {
      try {
        const network = this.isTestnet ? bitgotx.networks.fluxtestnet : bitgotx.networks.zelcash
        const explorer = this.isTestnet ? this.testnetExplorer : this.mainnetExplorer;
        const utx = await axios.get(`${explorer}/api/addr/${this.unsignedTx.myAddress}/utxo`);
        const utxos = utx.data;
        let satoshisSoFar = 0;
        let history = [];
        const satoshisToSend = Math.round(Number(this.unsignedTx.amount) * 1e8);
        const satoshisfeesToSend = 0;
        let recipients = [{
          address: this.unsignedTx.receiver,
          satoshis: satoshisToSend,
        }];
        for (let i = 0; i < utxos.length; i += 1) {
          if (utxos[i].height !== 0) {
            history = history.concat({
              txid: utxos[i].txid,
              vout: utxos[i].vout,
              scriptPubKey: utxos[i].scriptPubKey,
              satoshis: utxos[i].satoshis,
            });

            satoshisSoFar += utxos[i].satoshis;
            if (satoshisSoFar >= satoshisToSend + satoshisfeesToSend) {
              break;
            }
          }
        }
        const refundSatoshis = satoshisSoFar - satoshisToSend - satoshisfeesToSend;
        if (refundSatoshis > 0) {
          recipients = recipients.concat({
            address: this.unsignedTx.myAddress,
            satoshis: refundSatoshis,
          });
        }
        if (refundSatoshis < 0) {
          this.unsignedTx.hex = 'Insufficient amount';
          return;
        }
        const txb = new bitgotx.TransactionBuilder(network, satoshisfeesToSend);
        txb.setVersion(4);
        txb.setVersionGroupId(0x892F2085);
        history.forEach((x) => txb.addInput(x.txid, x.vout));
        recipients.forEach((x) => txb.addOutput(x.address, x.satoshis));
        if (this.unsignedTx.message !== '') {
          const data = Buffer.from(this.unsignedTx.message, "utf8");
          const dataScript = bitgotx.script.nullData.output.encode(data);
          txb.addOutput(dataScript, 0);
        }

        const tx = txb.buildIncomplete();
        this.unsignedTx.hex = tx.toHex()
      } catch (e) {
        console.log(e);
        this.unsignedTx.hex = e.message;
      }

    },
    async signTransaction() {
      try {
        const network = this.isTestnet ? bitgotx.networks.fluxtestnet : bitgotx.networks.zelcash
        const hashType = bitgotx.Transaction.SIGHASH_ALL;
        const txhex = this.signedTx.rawtx;
        const keyPair = bitgotx.ECPair.fromWIF(this.signedTx.privatekey, network);
        const txb = bitgotx.TransactionBuilder.fromTransaction(bitgotx.Transaction.fromHex(txhex, network), network);
        console.log(txb);
        let i = 0;
        // eslint-disable-next-line no-unused-vars
        for (const input of txb.inputs) {
          const hash = this.getValueHexBuffer(txb.tx.ins[i].hash.toString('hex'));
          const index = txb.tx.ins[i].index;
          console.log(txb.tx);
          console.log(hash);
          const explorer = this.isTestnet ? this.testnetExplorer : this.mainnetExplorer;
          const tx = await axios.get(`${explorer}/api/tx/${hash}`);
          const value = Math.round(Number(tx.data.vout[index].value) * 1e8);
          txb.sign(i, keyPair, Buffer.from(this.signedTx.redeemScript, 'hex'), hashType, value);
          i += 1;
        }
        const tx = txb.buildIncomplete();
        this.signedTx.hex = tx.toHex()
      } catch (e) {
        console.log(e);
        this.signedTx.hex = e.message;
      }
    },
    finaliseTransaction() {
      try {
        const network = this.isTestnet ? bitgotx.networks.fluxtestnet : bitgotx.networks.zelcash
        const txhex = this.finalisedTx.rawtx;
        const txb = bitgotx.TransactionBuilder.fromTransaction(bitgotx.Transaction.fromHex(txhex, network), network);
        const tx = txb.build();
        this.finalisedTx.hex = tx.toHex()
      } catch (e) {
        console.log(e);
        this.signedTx.hex = e.message;
      }
    },
    getValueHexBuffer(hex) {
      const buf = Buffer.from(hex, 'hex').reverse();
      return buf.toString('hex');
    },
  }
}
